/*
 * @description: 系统路由配置
 * @author: xuy
 * @since: 2020-03-31 11:03:46
 * @version: 1.0
 */
import PublicLayout from '@/framework/layout2/PublicLayout.vue'
export default [
    {
        path: '/registerUploadFile',
        component: PublicLayout,
        children: [
            {
                path: 'index',
                component: () => import('@/app/registerUploadFile/index'),
                name: 'registerUploadFile',
                meta: { title: 'module.registerUploadFile.098678-0', icon: '', noCache: true, breadcrumb: true, whiteList: true }
            }
        ]
    }
]
